import { constants } from '..';

const INITIAL_STATE = {
  loading: false,
  imageUploading: false,
  banners: [],
  total: 0,
  selectedBanner: {},
  bannerImage: {},
};

export const bannersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.banners.SET_BANNERS_LOADING:
      return {
        ...state,
        loading: action.flag,
      };
    case constants.banners.SET_BANNER_IMAGE_UPLOADING:
      return {
        ...state,
        imageUploading: action.flag,
      };
    case constants.banners.SET_BANNER_IMAGE:
      return {
        ...state,
        bannerImage: action.image,
      };
    case constants.banners.SET_BANNERS:
      return {
        ...state,
        banners: action.banners,
        total: action.count,
      };
    case constants.banners.SET_BANNER:
      return {
        ...state,
        selectedBanner: action.banner,
      };
    case constants.banners.CLEAR_BANNERS:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
